import * as z from "zod/v4";

import { partnerSummarySchema, partnerTypeSchema } from "./shared";

export const createPartner = {
  name: "createPartner" as const,
  input: z.object({
    email: z.string().email(),
    name: z.string().min(1).max(200),
    /** If omitted, the server auto-generates from `name`. */
    referralCode: z.string().min(3).max(20).optional(),
    partnerType: partnerTypeSchema,
    /**
     * When true, the server signs a magic link and attempts delivery as
     * part of the create flow. Failure does NOT roll back partner creation —
     * the response surfaces the failure tag so the admin UI can offer a
     * "resend" affordance.
     */
    sendMagicLinkImmediately: z.boolean().default(true),
  }),
  output: z.object({
    partner: partnerSummarySchema,
    magicLinkSent: z.boolean(),
    magicLinkError: z.string().optional(),
  }),
};
